import http from "../../Services/Auth/config/http-common";
import ICatClientes from "../../Interfaces/Catalogos/ICatClientes";
import IRespuesta from "../../Interfaces/Respuestas/IRespuesta";

class CatClientesDataService {
  async Get() {
    return await http.get<ICatClientes[]>("Catalogos/CatClientes/Get");
  }
  Append(data: ICatClientes) {
    return http.post<ICatClientes>(`Catalogos/CatClientes/Append`,data);
  }
  Delete(id: number) {
    return http.delete<IRespuesta>(`Catalogos/CatClientes/Delete/${id}`);
  }
}
export default new CatClientesDataService();